var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody } from '../../common';
import { AnnualTableHead } from '../annualTable';
import { useTableRowExpansion } from './selectors';
var IMPLICIT_CHILD_SEGMENTS = ['lob', 'deferrable', 'nonDeferrable', 'queue', 'multiSkill', 'group', 'country'];
export var getImplicitNestedExpansionItems = function (itemName, expansionItems) {
  return expansionItems.filter(function (item) {
    return IMPLICIT_CHILD_SEGMENTS.some(function (segment) {
      return item.startsWith("".concat(itemName, ":").concat(segment, ":"));
    });
  });
};
export var AnnualSectionTable = function (_a) {
  var title = _a.title,
    unit = _a.unit,
    expansionItems = _a.expansionItems,
    TableBodyComponent = _a.tableBodyComponent,
    getNestedExpansionItems = _a.getNestedExpansionItems,
    _b = _a.defaultExpanded,
    defaultExpanded = _b === void 0 ? false : _b,
    _c = _a.defaultExpandedItems,
    defaultExpandedItems = _c === void 0 ? [] : _c,
    sectionId = _a.sectionId;
  var expansion = useTableRowExpansion(expansionItems, defaultExpanded, defaultExpandedItems);
  var handleToggleItem = function (itemName) {
    var _a;
    var expanded = !expansion.expandedItems[itemName];
    var nestedItems = __spreadArray(__spreadArray([], (_a = getNestedExpansionItems === null || getNestedExpansionItems === void 0 ? void 0 : getNestedExpansionItems(itemName)) !== null && _a !== void 0 ? _a : [], true), getImplicitNestedExpansionItems(itemName, expansionItems), true);
    expansion.setItemsExpanded([itemName], expanded);
    expansion.setItemsExpanded(Array.from(new Set(nestedItems)), false);
  };
  return _jsxs(_Fragment, {
    children: [_jsx(AnnualTableHead, {
      title: title,
      unit: unit,
      isExpandable: true,
      expanded: expansion.someExpanded,
      onExpandToggle: expansion.toggleAll,
      sectionId: sectionId
    }), _jsx(TableBody, {
      children: _jsx(TableBodyComponent, {
        expandedItems: expansion.expandedItems,
        onToggleItem: handleToggleItem
      })
    })]
  });
};